<template>
  <div v-if="!isClassDataEmpty" class="">
    <div class="pa-3 pa-sm-4 pa-md-2">
      <Breadcrumbs
        v-if="classData"
        data="classData.title"
        :headline="`${classData.title} (${classData.code})`"
        :link="[
          { text: 'Lớp học', href: '../../../classes' },
          {
            text: `${classData.title} (${classData.code})`,
            id: classData.id,
            href: `../../class/${classData.id}`
          },
          { text: 'Phiếu Điểm' }
        ]"
      />
    </div>
    <v-card elevation="1" class="mt-3 mx-md-2 px-3">
      <v-layout v-if="classData">
        <v-flex md12 xs12 sm12>
          <div>
            <div>
              <div class="d-flex">
                <MarkBreadcrumb></MarkBreadcrumb>
              </div>
              <div v-if="canSeeMarkSheets">
                <BaseTableSkeletonLoader v-if="isLoading"></BaseTableSkeletonLoader>
                <div
                  class="d-flex flex-column flex-sm-row px-4 py-6 py-sm-2 align-center"
                  v-else-if="!(assignedMarkSheets || {}).length"
                >
                  <p class="mb-0">Không có phiếu điểm nào để hiển thị</p>
                  <v-btn
                    v-if="!isLocked && canCreate"
                    @click="onClickAddMarkSheet"
                    class="ml-0 ml-sm-2 mt-2 mt-sm-0"
                    :elevation="0"
                    color="primary"
                    text
                  >
                    Tạo phiếu điểm
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>
                <template v-else>
                  <div class="d-flex mt-2 justify-between align-end">
                    <v-tabs v-model="tabIndex" v-if="!$vuetify.breakpoint.mobile">
                      <v-tab v-for="(t, i) in tabs" :key="t.id" style="text-transform: none">
                        <div class="d-flex align-center">
                          <div style="max-width: 186px" class="flex-fill text-truncate">
                            {{ i + 1 }}. {{ t.text }}
                          </div>
                          <v-menu>
                            <template v-slot:activator="{ on }">
                              <v-btn text @click.stop="on.click" icon small class="ml-2">
                                <v-icon small>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list class="px-2" dense>
                              <v-list-item @click.stop="onClickShowMarkSheet(i)">
                                <v-list-item-icon>
                                  <v-icon small>mdi-eye</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>Xem chi tiết</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item
                                @click.stop="onClickExport()"
                                v-if="t.id === activeSheetId"
                              >
                                <v-list-item-icon>
                                  <v-icon small>mdi-file-excel</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>Xuất ra file Excel</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item
                                @click.stop="onClickDeleteMarkElementData(i)"
                                v-if="!isLocked && canCreate"
                              >
                                <v-list-item-icon>
                                  <v-icon small>mdi-delete</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>Xóa dữ liệu điểm </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item
                                @click.stop="onClickDeleteSheet(i)"
                                v-if="!isLocked && canCreate"
                              >
                                <v-list-item-icon>
                                  <v-icon small>mdi-delete</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>Xóa phiếu điểm </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                          <!-- <v-btn
                            small
                            class="ml-1"
                            title="Xem thông tin"
                            v-else
                            icon
                            @click.stop="onClickShowMarkSheet(i)"
                          >
                            <v-icon small> mdi-information </v-icon>
                          </v-btn> -->

                          <v-icon class="ml-1" small title="Đã khóa" color="grey " v-if="isLocked">
                            lock
                          </v-icon>
                        </div>
                      </v-tab>
                    </v-tabs>
                    <template v-else>
                      <v-select
                        hide-details="auto"
                        item-text="text"
                        item-value="index"
                        :items="tabs"
                        label="Phiếu điểm"
                        v-model="tabIndex"
                      ></v-select>
                      <v-menu>
                        <template v-slot:activator="{ on }">
                          <v-btn text @click.stop="on.click" icon small>
                            <v-icon small>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list class="px-2" dense>
                          <v-list-item @click.stop="onClickShowMarkSheet()">
                            <v-list-item-icon>
                              <v-icon small>mdi-eye</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Xem chi tiết</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item @click.stop="onClickExport()">
                            <v-list-item-icon>
                              <v-icon small>mdi-file-excel</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Xuất ra file Excel</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item
                            @click.stop="onClickDeleteMarkElementData()"
                            v-if="!isLocked && canCreate"
                          >
                            <v-list-item-icon>
                              <v-icon small>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Xóa dữ liệu điểm </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item @click.stop="onClickDeleteSheet()" v-if="canCreate">
                            <v-list-item-icon>
                              <v-icon small>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Xóa phiếu điểm </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                    <v-btn
                      @click="onClickAddMarkSheet"
                      class="ml-2"
                      :elevation="0"
                      color="primary"
                      v-if="!isLocked && canCreate"
                    >
                      <span v-if="$vuetify.breakpoint.smAndUp">Thêm phiếu điểm</span>
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                  <div class="mt-3 pl-3 d-flex align-center" v-if="selectedTab">
                    GV chấm: {{ selectedTab.assigned_teacher }}
                  </div>
                  <v-data-table
                    v-if="(assignedMarkSheets || {}).length"
                    item-class="row-class"
                    @click:row="onRowClick"
                    :headers="headers"
                    :items="tableData"
                    hide-default-footer
                    :disable-pagination="true"
                    :mobile-breakpoint="0"
                    disableSort
                  >
                    <template v-slot:item.index="{ item }">
                      {{ item.index + 1 }}
                    </template>
                    <template v-slot:item.name="{ item }">
                      {{ item.name }}
                      <!-- <v-tooltip v-if="!studentQualificationStatus[item._id]" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" slot="activator">mdi-information</v-icon>
                      </template>
                      Sinh viên không đủ điều kiện tham gia lớp học
                    </v-tooltip> -->
                    </template>
                    <template v-slot:item.actions="{ item }" v-if="!isLocked && canEdit">
                      <div class="d-flex align-center">
                        <v-btn
                          v-if="
                            (!shouldCheckQualification || studentQualificationStatus[item.id]) &&
                            item.learningResult.qualifyForFinalExam === true
                          "
                          text
                          icon
                          small
                          @click.stop="onClickEdit(item.id)"
                          title="Sửa điểm"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="isRowNotEmpty(item)"
                          text
                          icon
                          small
                          @click.stop="onClickDelete(item.id)"
                          title="Xóa điểm"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </template></v-data-table
                  >
                </template>
              </div>
              <p v-else class="px-4 py-2 pt-4 mb-0">Bạn không có quyền xem phiếu điểm</p>
            </div>
          </div>
        </v-flex></v-layout
      >
    </v-card>
    <BaseDialog
      v-if="editMarkElementsDialog.isOpen"
      :isOpen="editMarkElementsDialog.isOpen"
      :title="editMarkElementsDialog.title"
      @close="editMarkElementsDialog.isOpen = false"
      @cancel="editMarkElementsDialog.onCancel"
      @confirm="editMarkElementsDialog.callback"
      :isSubmitting="editMarkElementsDialog.isSubmitting"
    >
      <v-form lazy-validation ref="editMarkElementsDialog" @submit="onSubmitEditMarkElement">
        <v-card-text>
          <v-text-field
            v-for="item in courseMarkElements"
            :key="item.id"
            :label="`${item.title} (max: ${item.max})`"
            type="number"
            min="0"
            :max="item.max"
            step="0.5"
            v-model="editMarkElementsDialog.currentItem.course_mark_elements[item.id].value"
            required
            :rules="getRules(item.max)"
            hide-details="auto"
          >
          </v-text-field>
          <div class="pa-1">
            <p class="mb-0">Tổng điểm : {{ getToTalScore() }}</p>
          </div>
        </v-card-text>
        <input type="submit" class="d-none" />
      </v-form>
    </BaseDialog>
    <BaseDialog
      v-if="editMarkSheetDialog.isOpen"
      :isOpen="editMarkSheetDialog.isOpen"
      :title="editMarkSheetDialog.title"
      @close="editMarkSheetDialog.isOpen = false"
      @cancel="editMarkSheetDialog.onCancel"
      @confirm="editMarkSheetDialog.callback"
    >
      <v-form lazy-validation ref="editMarkSheetDialog">
        <v-card-text>
          <v-text-field
            :rules="[$rules.required]"
            required
            label="Tiêu đề"
            v-model="editMarkSheetDialog.currentItem.title"
          >
          </v-text-field>
          <!-- <v-autocomplete
            required
            :rules="[$rules.required]"
            v-model="editMarkSheetDialog.currentItem.assigned_teacher"
            item-text="name"
            :items="(classData || {}).grading_teachers"
            item-value="id"
            label="Giáo viên chấm"
          ></v-autocomplete> -->
          <autocomplete-teacher
            :rules="[$rules.required]"
            v-model="editMarkSheetDialog.currentItem.assigned_teacher"
            item-text="name"
            item-value="id"
            label="Giáo viên chấm"
          ></autocomplete-teacher>
          <v-textarea label="Mô tả" v-model="editMarkSheetDialog.currentItem.note"> </v-textarea>
        </v-card-text> </v-form
    ></BaseDialog>
    <BaseDialog
      v-if="showMarkSheetDialog.isOpen"
      :isOpen="showMarkSheetDialog.isOpen"
      :title="showMarkSheetDialog.title"
      @close="showMarkSheetDialog.isOpen = false"
      @confirm="showMarkSheetDialog.callback"
      @cancel="showMarkSheetDialog.onCancel"
      primaryText="Edit"
      secondaryText="Close"
      :hidePrimaryBtn="isLocked || !canCreate"
    >
      <v-card-text class="pt-3">
        <div class="show-mark-sheet-item">
          <div class="show-mark-sheet-label">Tạo bởi:</div>
          <div class="show-mark-sheet-value">
            {{ showMarkSheetDialog.currentItem.author }}
          </div>
        </div>
        <div class="show-mark-sheet-item">
          <div class="show-mark-sheet-label">Thời gian:</div>
          <div class="show-mark-sheet-value">
            {{ showMarkSheetDialog.currentItem.createdAt }}
          </div>
        </div>
        <div class="show-mark-sheet-item">
          <div class="show-mark-sheet-label">GV chấm:</div>
          <div class="show-mark-sheet-value">
            {{ showMarkSheetDialog.currentItem.assigned_teacher }}
          </div>
        </div>
        <div class="show-mark-sheet-item">
          <div class="show-mark-sheet-label">Mô tả:</div>
          <div class="show-mark-sheet-value">
            {{ showMarkSheetDialog.currentItem.note }}
          </div>
        </div>
      </v-card-text>
    </BaseDialog>
  </div>
</template>
<script>
import { saveAs } from 'file-saver'
import XLSX from 'xlsx'
import BaseDialog from '@/components/base/BaseDialog'
import { groupBy } from 'rxjs/internal/operators/groupBy.js'
import { mapState, mapActions, mapGetters } from 'vuex'
import BaseTableSkeletonLoader from '@/components/base/BaseTableSkeletonLoader'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import moment from 'moment'
import _ from 'lodash'
import AutocompleteTeacher from '@/components/basic/input/AutocompleteTeacher'
import MarkBreadcrumb from '@/modules/class/marks/MarkBreadcrumb'
import { round } from 'number-precision'

export default {
  components: {
    MarkBreadcrumb,
    AutocompleteTeacher,
    BaseDialog,
    Breadcrumbs,
    BaseTableSkeletonLoader
  },
  data() {
    return {
      isLoading: false,
      currentSheetId: null,
      tabIndex: 0,
      editMarkSheetDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        callback: () => {},
        onCancel: () => {
          this.editMarkSheetDialog.isOpen = false
        }
      },
      showMarkSheetDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        onCancel: () => {
          this.showMarkSheetDialog.isOpen = false
        },
        callback: () => {}
      },
      editMarkElementsDialog: {
        isSubmitting: false,
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        callback: () => {},
        onCancel: () => {
          this.editMarkElementsDialog.isOpen = false
        }
      }
    }
  },
  computed: {
    ...mapGetters('classDetail', ['classData', 'finalCourseMark']),
    ...mapState('classDetail', [
      'markSheets',
      'markElements',
      'students',
      // 'isLoadingMarkSheets',
      'courseMarkElements',
      'learningResults'
    ]),
    ...mapState('auth', ['user']),
    isLocked() {
      if (!this.classData) {
        return false
      }
      return this.classData.markTableLocked
    },
    shouldCheckQualification() {
      if (!((this.classData || {}).course_mark_config || {}).requireCondition) {
        return false
      }
      return true
    },

    studentQualificationStatus() {
      if (!((this.classData || {}).course_mark_config || {}).requireCondition) {
        return {}
      }
      if (!this.classData.students) {
        return {}
      }
      return Object.fromEntries(
        this.classData.students.map(i => {
          const qualified = !(this.classData.unqualified_students || []).find(j => j === i.id)
          return [i.id, qualified]
        })
      )
    },
    assignedMarkSheets() {
      if (!this.user) {
        return []
      }

      if (
        ['manager', 'accountant', 'education_manager', 'super_admin'].includes(this.user.role.type)
      ) {
        return this.markSheets
      }
      return this.markSheets.filter(
        ({ assigned_teacher }) => assigned_teacher.code === this.user.username
      )
    },
    isClassDataEmpty() {
      return _.isEmpty(this.classData)
    },
    canSeeMarkSheets() {
      if (!this.classData || !this.user || !this.user.role) {
        return false
      }
      if (
        ['manager', 'accountant', 'super_admin', 'education_manager'].includes(
          this.user.role.type
        ) ||
        (this.classData.grading_teachers || []).find(i => i.code === this.user.username)
      ) {
        return true
      }
      return false
    },
    activeSheetId() {
      return ((this.assignedMarkSheets || [])[this.tabIndex] || {}).id
    },

    canEdit() {
      if (!this.user || !this.classData) {
        return false
      }
      if (this.activeSheetId === null) {
        return false
      }
      const match = _.cloneDeep(
        (this.assignedMarkSheets || []).find(s => s.id === this.activeSheetId)
      )
      if (!match) {
        return false
      }
      return (
        ['education_manager', 'super_admin'].includes(this.user.role.type) ||
        match.assigned_teacher.code === this.user.username
      )
    },
    headers() {
      if (!this.courseMarkElements) {
        return []
      }
      const output = this.courseMarkElements
        .map(i => i)
        .sort((a, b) => (a.index || 0) - (b.index || 0))
        .map(i => ({
          value: `course_mark_elements.${i.id}.value`,
          text: `${i.title}(${i.max})`,
          align: 'start',
          sortable: false
        }))

      return [
        { value: 'index', text: 'STT', align: 'left', sortable: false },
        { value: 'name', text: 'Họ và tên', align: 'left', sortable: false },
        { value: 'tags', text: 'Nhóm lớp', align: 'left', sortable: false },
        ...output,
        { text: 'Tổng điểm', value: 'course_mark_elements.total.value', sortable: false },
        { text: 'Hành động', value: 'actions', sortable: false }
      ]
    },
    tableData() {
      if (!this.activeSheetData) {
        return []
      }
      const raw = this.activeSheetData.map(i => {
        const total = Object.values(i.course_mark_elements).some(
          j => j.value === undefined || j.value === null
        )
          ? undefined
          : _.round(
              _.sumBy(Object.values(i.course_mark_elements), i => i.value || 0),
              2
            )
        return {
          ...i,
          course_mark_elements: {
            ...i.course_mark_elements,
            total: {
              id: 'total',
              value: total
            }
          },
          'row-class': [
            'row-class',
            ...(!this.shouldCheckQualification || this.studentQualificationStatus[i.id]
              ? []
              : ['unqualified-student']),
            ...((i.learningResult || {}).qualifyForFinalExam === true
              ? []
              : ['unqualify-final-exam'])
          ]
        }
      })
      const twoGroup = _.partition(raw, i => {
        const qualified =
          i.learningResult.qualifyForFinalExam === true &&
          (!this.shouldCheckQualification || this.studentQualificationStatus[i.id])

        return qualified
      })

      return twoGroup.flat().map((i, index) => ({ ...i, index }))
    },
    activeSheetData() {
      if (!this.courseMarkElements) {
        return []
      }
      if (!this.students) {
        return []
      }
      if (this.activeSheetId === null) {
        return []
      }
      const match = _.cloneDeep(this.assignedMarkSheets.find(s => s.id === this.activeSheetId))
      if (!match) {
        return []
      }
      match.mark_elements = _.groupBy(
        this.markElements.filter(i => i.final_mark_sheet.id === this.activeSheetId),
        i => i.student.id
      )
      // const markElements = [...this.markElements]
      const output = Object.values(this.students).map(({ id: sid, ...os }) => {
        const learningResult = this.learningResults.find(ls => ls.student.id === sid) || {}
        const course_mark_elements = this.courseMarkElements.map(({ id: cmid, ...ocm }) => {
          const matchMarkElm = (match.mark_elements[sid] || []).find(
            item => item.course_mark_element.id === cmid
          )
          return {
            ...ocm,
            id: cmid,
            value: !matchMarkElm ? undefined : matchMarkElm.value,
            markElementId: !matchMarkElm ? undefined : matchMarkElm.id
          }
        })

        return {
          ...os,
          learningResult,
          id: sid,
          course_mark_elements: _.keyBy(course_mark_elements, i => i.id)
        }
      })
      return output
    },
    grading_teachers() {
      return (this.classData || {}).grading_teachers
    },
    currentMarkSheet() {
      if (!this.currentSheetId) {
        return
      }
      const markSheet = _.cloneDeep(this.assignedMarkSheets.find(i => i.id === this.currentSheetId))
      if (!markSheet) {
        return
      }
      markSheet.markData = groupBy(markSheet.mark_elements, i => i.student)
      return markSheet
    },
    finalCourseMark() {
      if (!this.classData) {
        return undefined
      }
      if (!this.classData.course_mark_config.course_marks) {
        return undefined
      }
      return this.classData.course_mark_config.course_marks.find(m => m.type === 'final')
    },
    canCreate() {
      if (!this.user) {
        return false
      }
      return ['education_manager', 'super_admin'].includes(this.user.role.type)
    },
    tabs() {
      if (!this.user) {
        return []
      }
      return (this.assignedMarkSheets || [])
        .map(({ title, assigned_teacher, note, author, createdAt, id }) => {
          const userName = author.username
          const allowedToSee =
            ['manager', 'accountant', 'education_manager', 'super_admin'].includes(
              this.user.role.type
            ) || this.user.username === assigned_teacher.code
          if (!allowedToSee) {
            return
          }
          return {
            text: title,
            createdAt: moment(createdAt).format('D MMM, YYYY'),
            id,
            author: userName,
            assigned_teacher: assigned_teacher.name,
            note
          }
        })
        .filter(Boolean)
        .map((i, index) => ({ ...i, index }))
    },
    selectedTab() {
      return this.tabs[this.tabIndex]
    }
  },
  watch: {
    assignedMarkSheets() {
      if (!this.activeSheetId && (this.assignedMarkSheets || {}).length) {
        this.activeSheetId = this.assignedMarkSheets[0].id
      }
    },
    classData() {
      if (!this.classData) {
        return
      }
      this.fetchCourseMarkElements(this.classData.course_mark_config.id)
    }
  },
  methods: {
    ...mapActions('classDetail', [
      'createManyMarkElements',
      'createMarkSheet',
      'fetchMarkSheets',
      'fetchMarkSheet',
      'fetchMarkElements',
      'initClass',
      'fetchCourseMarkElements',
      'removeStudentMarkElements',
      'updateManyMarkElements',
      'updateMarkSheet',
      'deleteMarkSheet',
      'deleteAllMarkElementsOfSheet'
    ]),
    onSubmitEditMarkElement(e) {
      e.preventDefault()
      console.log('submit')
      this.editMarkElementsDialog.callback()
    },
    onClickExport() {
      const data = this.tableData
        .map(({ name, course_mark_elements }) => {
          const { total, ...o } = course_mark_elements
          return {
            'Họ và tên': name,
            ...Object.fromEntries(
              Object.values(o).map(({ max, value, title }, index) => [
                `${index + 1}. ${title}(${max})`,
                value
              ])
            ),
            'Tổng điểm': total.value
          }
        })
        .filter(Boolean)
      const ws = XLSX.utils.json_to_sheet(data, { skipHeader: false, origin: 'A1' })
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws)
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      saveAs(blob, `${this.classData.code}_phieudiem_${moment().format('YYYY-MM-DD')}.xlsx`)
    },

    isRowNotEmpty(item) {
      const course_mark_elements = item.course_mark_elements
      if (!course_mark_elements) return false
      const arr = Object.values(course_mark_elements).filter(i => i.id !== 'total')
      if (!_.isEmpty(arr) && arr.some(i => i.value !== undefined)) {
        return true
      }
      return false
    },
    onRowClick(item) {
      if (this.isLocked) {
        return
      }
      if (!this.canEdit) {
        return
      }
      if (this.shouldCheckQualification && !this.studentQualificationStatus[item.id]) {
        return
      }
      if (item.learningResult.qualifyForFinalExam !== true) {
        return
      }
      this.onClickEdit(item.id)
    },
    onClickDeleteSheet(tabIndex) {
      if (tabIndex === undefined) {
        tabIndex = this.tabIndex
      }
      const sheetId = this.tabs[tabIndex].id
      this.$dialog.confirm({
        title: 'Xóa phiếu điểm',
        text: 'Xóa phiếu điểm, và các liên kết sử dụng phiếu điểm này',
        okText: 'Yes',
        cancelText: 'No',
        done: (async () => {
          try {
            await this.deleteMarkSheet(sheetId)
            if (tabIndex >= this.tabIndex && this.tabIndex >= 1) {
              this.tabIndex--
            }
            this.$alert.success('Xóa thành công')
          } catch (error) {
            this.$alert.error('Có lỗi xảy ra')
          } finally {
            this.fetchMarkElements(this.$route.params.id)
          }
        }).bind(this)
      })
    },
    onClickDeleteMarkElementData(tabIndex) {
      if (tabIndex === undefined) {
        tabIndex = this.tabIndex
      }
      const sheetId = this.tabs[tabIndex].id
      this.$dialog.confirm({
        title: 'Xóa dữ liệu điểm',
        text: 'Xóa tất cả dữ liệu điểm thuộc phiếu điểm này',
        okText: 'Yes',
        cancelText: 'No',
        done: (async () => {
          try {
            await this.deleteAllMarkElementsOfSheet(sheetId)
            this.$alert.success('Xóa thành công')
          } catch (error) {
            this.$alert.error('Có lỗi xảy ra')
          } finally {
            this.fetchMarkElements(this.$route.params.id)
            this.fetchMarkSheets(this.$route.params.id)
          }
        }).bind(this)
      })
    },
    onClickShowMarkSheet(tabIndex) {
      if (tabIndex === undefined) {
        tabIndex = this.tabIndex
      }
      const selectedTab = this.tabs[tabIndex]
      if (!selectedTab) {
        return
      }
      this.showMarkSheetDialog.isOpen = true
      this.showMarkSheetDialog.title = selectedTab.text
      this.showMarkSheetDialog.currentItem = _.cloneDeep(selectedTab)
      this.showMarkSheetDialog.callback = () => {
        this.showMarkSheetDialog.isOpen = false
        this.onClickEditMarkSheet(selectedTab.id)
      }
    },
    onClickEditMarkSheet(sheetId) {
      if (this.isLocked) {
        return
      }
      if (!sheetId && (!this.activeSheetId || !this.assignedMarkSheets)) {
        return
      }
      const trueSheetId = sheetId || this.activeSheetId
      const match = this.assignedMarkSheets.find(s => s.id === trueSheetId)
      if (!match) {
        return
      }
      this.editMarkSheetDialog.isOpen = true
      this.editMarkSheetDialog.title = 'Sửa phiếu điểm'
      this.editMarkSheetDialog.currentItem = _.cloneDeep(match)
      this.editMarkSheetDialog.callback = (async () => {
        if (this.isLocked) {
          return
        }
        this.editMarkSheetDialog.valid = this.$refs.editMarkSheetDialog.validate()
        if (!this.editMarkSheetDialog.valid) {
          this.$alert.error('Lỗi form! Vui lòng kiểm tra lại')
          return
        }
        if (!trueSheetId) {
          this.editMarkSheetDialog.onCancel()
          return
        }
        try {
          if (!this.editMarkSheetDialog.currentItem) {
            return
          }
          const { assigned_teacher, note, title } = this.editMarkSheetDialog.currentItem

          await this.updateMarkSheet({
            id: trueSheetId,
            ...{
              assigned_teacher,
              note,
              title
            }
          })
          this.$alert.success('Cập nhật thành công')
        } catch (error) {
          this.$alert.error('Có lỗi xảy ra')
        } finally {
          this.editMarkSheetDialog.onCancel()
        }
      }).bind(this)
    },
    getRules(max) {
      return [this.$rules.required, this.$rules.max(max)]
    },
    getToTalScore() {
      if (!this.editMarkElementsDialog.currentItem) {
        return
      }
      return _.round(
        _.sumBy(Object.values(this.editMarkElementsDialog.currentItem.course_mark_elements), i => {
          const valueText = (i.value || 0).toString()
          const value = parseFloat(valueText)
          return value || 0
        }),
        2
      )
    },
    async onClickDelete(studentId) {
      this.$dialog.confirm({
        title: 'Xóa điểm',
        text: 'Xóa điểm, và các liên kết sử dụng điểm này',
        okText: 'Yes',
        cancelText: 'No',
        done: (async () => {
          try {
            if (!this.activeSheetId) {
              return
            }
            await this.removeStudentMarkElements({ studentId, sheetId: this.activeSheetId })
            this.$alert.success('Cập nhật thành công')
          } catch (error) {
            this.$alert.error('Có lỗi xảy ra')
            this.fetchMarkElements(this.$route.params.id)
          }
        }).bind(this)
      })
    },

    onClickEdit(studentId) {
      if (!(this.activeSheetData || {}).length) {
        return
      }

      const matchStudent = this.activeSheetData.find(st => st.id === studentId)
      if (!matchStudent) {
        return
      }
      if (!(this.courseMarkElements || []).length) {
        this.$alert.error('Chưa có thành tố cho điểm cuối môn!')
        return
      }
      this.$alert.close()
      this.editMarkElementsDialog.currentItem = _.cloneDeep(matchStudent)
      this.editMarkElementsDialog.isOpen = true
      this.editMarkElementsDialog.title = 'Cập nhật điểm - ' + matchStudent.name
      const isEdit = Object.values(
        this.editMarkElementsDialog.currentItem.course_mark_elements
      ).every(i => i.markElementId !== undefined)
      this.editMarkElementsDialog.callback = (async () => {
        if (this.isLocked) {
          return
        }
        this.editMarkElementsDialog.valid = this.$refs.editMarkElementsDialog.validate()
        if (!this.editMarkElementsDialog.valid) {
          this.$alert.error('Lỗi Form! Vui lòng kiểm tra lại')
          return
        }
        if (!this.activeSheetId || !this.user || !this.classData) {
          return
        }
        const studentId = this.editMarkElementsDialog.currentItem.id
        const classId = this.classData.id
        const payload = Object.values(
          this.editMarkElementsDialog.currentItem.course_mark_elements
        ).map(el => {
          const { value, id: course_mark_element, course_mark, markElementId } = el

          return {
            final_mark_sheet: this.activeSheetId,
            course_mark_element,
            course_mark: course_mark.id,
            student: studentId,
            value: round(parseFloat((value || 0).toString()) || 0, 2),
            class: classId,
            ...(markElementId && {
              markElementId
            })
          }
        })
        try {
          this.editMarkElementsDialog.isSubmitting = true
          if (isEdit) {
            await this.updateManyMarkElements({
              data: payload
            })
            this.fetchMarkSheet(this.activeSheetId)
          } else {
            await this.createManyMarkElements({
              sheetId: this.activeSheetId,
              data: { data: payload }
            })
          }
          this.$alert.success('Cập nhật thành công')
        } catch (error) {
          this.$alert.error('Có lỗi xảy ra')
          // this.fetchMarkElements(this.$route.params.id)
        } finally {
          await this.fetchMarkElements(this.$route.params.id)
          this.editMarkElementsDialog.isSubmitting = false
          this.editMarkElementsDialog.isOpen = false
        }
      }).bind(this)
    },
    async onClickAddMarkSheet() {
      if (!this.finalCourseMark) {
        this.$alert.error('Môn học chưa có điểm cuối môn! Không thể tạo phiếu điểm')
        return
      }
      // if (!((this.classData || {}).grading_teachers || {}).length) {
      //   this.$alert.error('Chưa có giáo viên chấm điểm nào, vui lòng chỉnh sửa cấu hình lớp học')
      //   return
      // }
      this.editMarkSheetDialog.isOpen = true
      this.editMarkSheetDialog.title = 'Thêm phiếu điểm'
      this.editMarkSheetDialog.currentItem = {
        title: `Phiếu điểm số ${(this.assignedMarkSheets || []).length + 1}`,
        note: '',
        assigned_teacher: undefined
      }
      this.editMarkSheetDialog.callback = (async () => {
        this.editMarkSheetDialog.valid = this.$refs.editMarkSheetDialog.validate()
        if (!this.editMarkSheetDialog.valid) {
          this.$alert.error('Lỗi form! Vui lòng kiểm tra lại')
          return
        }

        try {
          if (!this.editMarkSheetDialog.currentItem) {
            return
          }
          const { assigned_teacher, note, title } = this.editMarkSheetDialog.currentItem
          await this.createMarkSheet({
            data: {
              isLocked: false,
              course: this.classData.course.id,
              course_mark_config: this.classData.course_mark_config.id,
              class: this.classData.id,
              course_mark: this.finalCourseMark.id,
              author: this.user.id,
              ...(title && { title }),
              ...(note && { note }),
              ...(assigned_teacher.length && { assigned_teacher })
            }
          })
          if ((this.assignedMarkSheets || {}).length)
            this.tabIndex = this.assignedMarkSheets.length - 1
          this.$alert.success('Tạo phiếu điểm thành công')
        } catch (error) {
          this.$alert.error('Có lỗi xảy ra')
          this.fetchMarkSheets(this.$route.params.id)
        } finally {
          this.editMarkSheetDialog.onCancel()
        }
      }).bind(this)
    },
    async init() {
      this.isLoading = true
      await Promise.allSettled([
        this.initClass({ id: this.$route.params.id }),
        this.fetchMarkSheets(this.$route.params.id),
        this.fetchMarkElements(this.$route.params.id)
      ])
      this.isLoading = false
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

::v-deep {
  th,
  td {
    background-color: #fff;
  }
  th {
    z-index: 1;
  }
  th:first-child {
    z-index: 2;
  }
  thead {
    tr:first-child th {
      position: sticky;
      top: -1px;
    }
    tr:nth-child(2) th {
      position: sticky;
      top: 64px;
    }
    th {
      z-index: 1;
    }
  }

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
  }

  .v-data-table__wrapper {
    height: calc(100vh - 300px);
    overflow-x: auto;
    overflow-y: auto;
  }

  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    .v-data-table__wrapper {
      height: calc(100vh - 313px);
    }
  }
  .row-class {
    cursor: pointer;
  }
  .row-class.unqualified-student,
  .row-class.unqualify-final-exam {
    cursor: default;
  }
  --disabled-color: rgb(218, 218, 218);

  .unqualified-student td {
    background-color: var(--disabled-color);
    .v-data-table__checkbox {
      display: none;
    }
  }
  .unqualify-final-exam td {
    background-color: var(--disabled-color);
  }
}

.show-mark-sheet-item {
  display: block;
}
.show-mark-sheet-label {
  width: 200px;
  display: inline-block;
}
.show-mark-sheet-value {
  display: inline;
}
</style>
